import React, { useMemo } from "react";
import { InfiniteList2 } from "../../../../../common/components";
import UsersListRow from "../users-list-row/UsersListRow";
import { translate } from "../../../../../common/providers";
import styles from "./UsersListTable.module.css";

export default function UsersListTable({
	usersRequest,
	COMPANY_ROLES,
	loggedUser,
	onChangeRole,
	onRegenPassword,
	onChangeLock,
	onSelectRow,
	selectedUser,
}) {
	const tableHeaders = useMemo(
		() => ({
			displayName: translate("dsi.user-list.th.name"),
			ADMIN: translate("dsi.user-list.th.admin"),
			MANAGER: translate("dsi.user-list.th.manager"),
			MEMBER: translate("dsi.user-list.th.member"),
			actions: translate("dsi.user-list.th.actions"),
		}),
		[]
	);
	const rowRenderer = (row) => (
		<UsersListRow
			COMPANY_ROLES={COMPANY_ROLES}
			loggedUser={loggedUser}
			row={row}
			selectedUser={selectedUser}
			onChangeLock={onChangeLock}
			onChangeRole={onChangeRole}
			onRegenPassword={onRegenPassword}
			onSelectRow={onSelectRow}
		/>
	);
	return (
		<>
			<UsersListRow isHeader COMPANY_ROLES={COMPANY_ROLES} row={tableHeaders} />
			<InfiniteList2 className={styles.container} request={usersRequest} rowRenderer={rowRenderer} />
		</>
	);
}
